import { API } from "./apiAbstract";
import MessagingApi from "./messagingApi";
import OrganizationsApi from "./organizationsApi";
import PublicTribesApi from "./publicTribesApi";
import UserApi from "./userApi";
import PublicationsApi from "./publicationsApi";
import PollsApi from "./pollsApi";
import ProfileApi from "./profileApi";
import BiolockApi from "./biolockApi";

let pollsApi: PollsApi;
let orgApi: OrganizationsApi;
let publicTribesApi: PublicTribesApi;
let userApi: UserApi;
let messagingApi: MessagingApi;
let publicationsApi: PublicationsApi;
let profileApi: ProfileApi;
let biolockApi: BiolockApi;

export function getPollsApi(): PollsApi {
  if (pollsApi === undefined) {
    pollsApi = new PollsApi();
  }
  return pollsApi;
}

export function getOrganizationsApi(): OrganizationsApi {
  if (orgApi === undefined) {
    orgApi = new OrganizationsApi();
  }
  return orgApi;
}

export function getPublicTribesApi(): PublicTribesApi {
  if (publicTribesApi === undefined) {
    publicTribesApi = new PublicTribesApi();
  }
  return publicTribesApi;
}

export function getUserApi(): UserApi {
  if (userApi === undefined) {
    userApi = new UserApi();
  }
  return userApi;
}

export function getMessagingApi(): MessagingApi {
  if (messagingApi === undefined) {
    messagingApi = new MessagingApi();
  }
  return messagingApi;
}

export function getPublicationsApi(): PublicationsApi {
  if (publicationsApi === undefined) {
    publicationsApi = new PublicationsApi();
  }
  return publicationsApi;
}

export function getProfileApi(): ProfileApi {
  if (profileApi === undefined) {
    profileApi = new ProfileApi();
  }
  return profileApi;
}

export function getBiolockApi(): BiolockApi {
  if (biolockApi === undefined) {
    biolockApi = new BiolockApi();
  }
  return biolockApi;
}

export function getAPI(name: string): API {
  switch (name) {
    case "poll":
    case "polls":
      return getPollsApi();
    case "organization":
    case "organizations":
      return getOrganizationsApi();
    case "public-tribes":
    case "publictribes":
      return getPublicTribesApi();
    case "user":
    case "users":
      return getUserApi();
    case "messaging":
      return getMessagingApi();
    case "publications":
      return getPublicationsApi();
    default:
      throw new Error(`No API '${name}' found`);
  }
}

export { type API };
